export default function(route) {
  return [
    {
      vmid: "og:url",
      property: "og:url",
      content: `${process.env.VUE_APP_BASE_URL}${route.fullPath}`,
    },
    {
      vmid: "og:type",
      property: "og:type",
      content: "article",
    },
    {
      vmid: "twitter:site",
      name: "twitter:site",
      content: `${process.env.VUE_APP_BASE_URL}${route.fullPath}`,
    },
    {
      vmid: "og:image",
      property: "og:image",
      content: process.env.VUE_APP_BASE_URL + "/banner-legisla.png",
    },
    {
      vmid: "og:image:secure_url",
      property: "og:image:secure_url",
      content: process.env.VUE_APP_BASE_URL + "/banner-legisla.png",
    },
    {
      vmid: "og:image:type",
      property: "og:image:type",
      content: "image/jpeg",
    },
    {
      vmid: "twitter:image",
      name: "twitter:image",
      property: "twitter:image",
      content: process.env.VUE_APP_BASE_URL + "/banner-legisla.png",
    },
    {
      vmid: "og:image:width",
      property: "og:image:width",
      content: "1201",
    },
    {
      vmid: "og:image:height",
      property: "og:image:height",
      content: "631",
    },
  ];
}
